import React from "react";
import TeamManagement from "../Pages/TeamManagement/TeamManagement";
import PlayerManagement from "../Pages/PlayerManagement/PlayerManagement";
import ManageDisplay from "../Pages/ManageDisplay/ManageDisplay";
const AdministrationLogin = React.lazy(() => import("../Pages/AdminLogin"));

const publicRoutes = [{ path: "/", component: AdministrationLogin }];

const protectedRoutes = [
  {
    path: "/manage-teams",
    exact: true,
    component: TeamManagement,
  },
  {
    path: "/manage-players",
    exact: true,
    component: PlayerManagement,
  },
  {
    path: "/manage-display",
    exact: true,
    component: ManageDisplay,
  },
];

export { protectedRoutes, publicRoutes };
